/**
 * Per-app injection token for GPI payment telemetry.
 *
 * The shared {@link GpiPayfieldService} (and the payment-POST consumers) log GPI failures through
 * this token instead of a concrete App Insights service, because the correct sink differs by app:
 * the EMR build provides `AppInsightsService`, the patient portal provides `PortalAppInsightsService`
 * (the EMR sink is a no-op on portal surfaces). Both already implement `logEvent`/`logTrace` with
 * identical signatures, so each app root aliases this token to its own sink via `useExisting`.
 */
export abstract class GpiTelemetry {
  abstract logEvent(name: string, properties?: Record<string, unknown>): void;
  abstract logTrace(message: string, properties?: Record<string, unknown>): void;
}
